import React from "react";

import Modals from "../popupModal/modal";

const SubscriptionReminder = ({ isOpen, onSuccess, closeModal }) => {
  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title="Subscription Update"
      styles={{
        content: {
          minWidth: "552px",
          maxWidth: "552px",
          minHeight: "450px",
          maxHeight: "450px",
        },
      }}
      btnDark={{
        label: "Subscribe",
        onclick: () => {
          onSuccess();
          closeModal();
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center denyAppointmentText">
          You don't have any active subscription. Please subscribe to any plan
          to be visible to patients so they can schedule appointment with you.
          Till then no patient will be able to schedule any appointments with
          you. You can still see the details of all previous appointments and
          patient information.
        </p>
      </React.Fragment>
    </Modals>
  );
};

export default SubscriptionReminder;
